import React from 'react'
import XLSX from "sheetjs-style";
import { saveAs } from 'file-saver';
import { TextButton } from './Buttons';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Tooltip from '@mui/material/Tooltip';

export default function ExcelExport({ filename, excelData, colorMap }) {

	const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";

	function handleDownloadExcel() {
		// Remove metadata fields (prefixed with _) from export data
		const cleanedData = excelData.map(row => {
			const cleanedRow = {};
			Object.keys(row).forEach(key => {
				if (!key.startsWith('_')) {
					cleanedRow[key] = row[key];
				}
			});
			return cleanedRow;
		});

		const ws = XLSX.utils.json_to_sheet(cleanedData);
		
		// Apply background colors to group total rows if colorMap is provided
		if (colorMap) {
			for (let dataIndex = 0; dataIndex < excelData.length; dataIndex++) {
				const rowData = excelData[dataIndex];
				
				// Only color group total rows
				if (rowData._isGroupTotal && rowData._groupName && colorMap[rowData._groupName]) {
					const rgbColor = colorMap[rowData._groupName];
					const excelRowNum = dataIndex + 2; // Account for header row
					
					// Apply color to all cells in this row
					for (let col = 0; col < Object.keys(cleanedData[dataIndex]).length; col++) {
						const colLetter = XLSX.utils.encode_col(col);
						const cellRef = colLetter + excelRowNum;
						
						if (ws[cellRef]) {
							ws[cellRef].s = {
								fill: {
									fgColor: { rgb: rgbColor },
								},
							};
						}
					}
				}
			}
		}
		
		const excelBuffer = XLSX.write(
			{
				Sheets: { data: ws },
				SheetNames: ["data"],
			},
			{ bookType: "xlsx", type: "array" }
		);
		const exportData = new Blob([excelBuffer], { type: fileType });
		saveAs(exportData, filename + fileExtension);
	}

	return (
		<div>
			<Tooltip title="Print">
				<TextButton variant="text" onClick={handleDownloadExcel} aria-label="Print Ledger Summary">
					<LocalPrintshopOutlinedIcon />
				</TextButton>
			</Tooltip>
		</div>
	)
}
